/**
 * Boho Brasil — mantém produtos esgotados sempre por último.
 *
 * O Liquid já renderiza cada página de resultados da coleção com os
 * disponíveis primeiro e os esgotados por último (ver sections/main-collection.liquid
 * e sections/product-list.liquid). Este script é só uma camada extra de segurança
 * para o scroll infinito das páginas de categoria: quando uma nova página de
 * produtos é anexada à grade, ele reordena a grade inteira para que TODOS os
 * itens esgotados (de qualquer página já carregada) fiquem depois de TODOS
 * os disponíveis.
 */
(function () {
  var GRID_SELECTOR = '#ResultsList .product-grid[data-testid="product-grid"]';

  function sortGrid(grid) {
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.children);
    if (items.length === 0) return;

    var available = [];
    var soldOut = [];

    items.forEach(function (item) {
      if (item.getAttribute('data-available') === 'false') {
        soldOut.push(item);
      } else {
        available.push(item);
      }
    });

    if (soldOut.length === 0 || available.length === 0) return;

    // Já está ordenado quando o primeiro esgotado vem logo depois do último disponível.
    var firstSoldOutIndex = items.indexOf(soldOut[0]);
    var alreadySorted = firstSoldOutIndex === available.length;
    if (alreadySorted) return;

    var fragment = document.createDocumentFragment();
    available.forEach(function (item) {
      fragment.appendChild(item);
    });
    soldOut.forEach(function (item) {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);
  }

  function sortAllGrids() {
    document.querySelectorAll(GRID_SELECTOR).forEach(sortGrid);
  }

  function observeGrid(grid) {
    if (!grid || grid.bbOutOfStockObserved) return;
    grid.bbOutOfStockObserved = true;

    var observer = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });
      if (hasAddedNodes) sortGrid(grid);
    });

    observer.observe(grid, { childList: true });
  }

  function init() {
    sortAllGrids();
    document.querySelectorAll(GRID_SELECTOR).forEach(observeGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Filtros e troca de seção (ex: app de filtros) podem substituir a grade inteira.
  document.addEventListener('shopify:section:load', init);
})();
